// extracted by mini-css-extract-plugin
export default {"wrapper":"u4mYV","wrapper__content":"dXY43"};